<div
  class="digital-platform-dropdown-wrapper"
  tabIndex="0"
  (click)="!control?.disabled && focusEvent()"
  (blur)="!control?.disabled && blurEvent()"
  (mouseover)="hovered = !control?.disabled && variant === 'base'"
  (mouseout)="hovered = false"
>
  <label
    *ngIf="value.length > 0"
    [for]="name"
    class="digital-platform-input-label {{ variant }}"
    >{{ placeholder }}</label
  >
  <img
    role="button"
    tabindex="0"
    alt="toggle dropdown"
    *ngIf="!control?.disabled && variant === 'base'"
    class="icon-right {{ variant }}"
    src="/assets/icons/{{ opened ? 'chevron-up' : 'chevron-down' }}.svg"
  />
  <img
    alt="toggle dropdown"
    *ngIf="control?.disabled && variant === 'base'"
    class="icon-right {{ variant }}"
    src="/assets/icons/chevron-down-disabled.svg"
  />
  <img
    alt="toggle dropdown"
    role="button"
    tabindex="0"
    *ngIf="variant === 'form'"
    class="icon-right {{ variant }}"
    src="/assets/icons/unfold.svg"
  />
  <input
    type="text"
    [placeholder]="placeholder"
    [value]="value"
    [name]="name"
    [id]="id"
    [disabled]="control?.disabled"
    [ngClass]="{
      'ng-dirty': control?.dirty,
      'ng-invalid': isTouchedAndInvalid(),
      'ng-pristine': control?.pristine,
      'ng-touched': control?.touched,
      disabled: control?.disabled,
      'ng-required': required,
      active: value.length > 0,
      hovered: hovered
    }"
    class="digital-platform-input form-control with-icon-right {{
      variant
    }} shadow-none dropdown-input"
    (blur)="onBlur()"
  />
  <!-- Regular Dropdown -->
  <div
    class="option-panel {{ variant }}"
    [class.option-panel-scroll]="options && options.length > 7"
    *ngIf="opened && options && options.length > 0"
  >
    <div
      class="option"
      (click)="selectOption({
      text:  'Select Business Type',
      value: '',
      })"
    ></div>
    <div
      *ngFor="let option of options"
      class="option"
      (click)="selectOption(option)"
      [attr.data-automation-id]="option.text"
    >
      {{ option.text }}
    </div>
  </div>

  <!-- Sectioned Dropdown -->
  <div
    class="option-panel {{ variant }}"
    [class.option-panel-scroll]="sectionedOptionsLength > 5"
    *ngIf="opened && sectionedOptions && sectionedOptions.length > 0"
  >
    <div *ngFor="let childObject of sectionedOptions">
      <span class="sectioned-header">{{ childObject.title }}</span>
      <div
        *ngFor="let option of childObject.list"
        class="option"
        (click)="selectOption(option)"
      >
        {{ option.text }}
      </div>
    </div>
  </div>

  <div *ngIf="isTouchedAndInvalid()" class="invalid-container">
    <img
      class="invalid-icon"
      alt="invalid"
      src="/assets/icons/triangle-exclamation.svg"
    />
    <small class="error-message">{{ errorMessage }}</small>
  </div>
</div>
